export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 4.13,
        "transcript": "...llruut-qaa, iciw' kinrumassiyaagluteng?",
        "translation": "...did they [?], you know, dried too much?"
    },
    "2": {
        "startTime": 5.54,
        "endTime": 10.31,
        "transcript": "Qaillun-wa imkut yullret take care-alallruit akluteng.",
        "translation": "I'm not sure how people long ago took care of their clothes."
    },
    "3": {
        "startTime": 10.59,
        "endTime": 17.32,
        "transcript": "Ilait ak'anun pikumaaqluki mecungtevkaqsaunaki.",
        "translation": "They would keep some for a very long time, keeping them from getting wet."
    },
    "4": {
        "startTime": 17.55,
        "endTime": 23.98,
        "transcript": "Mecungceteksaunaki, kucirceteksaunaki ellallugmek, camun mermun.",
        "translation": "They wouldn't let them get wet, wouldn't let rain fall on the drip, any kind of water."
    },
    "5": {
        "startTime": 33.59,
        "endTime": 37.18,
        "transcript": "Kinqautelallrat-qaa navguvkalarai?",
        "translation": "Does drying up make them break?"
    },
    "6": {
        "startTime": 37.18,
        "endTime": 38.04,
        "transcript": "Cat?",
        "translation": "What?"
    },
    "7": {
        "startTime": 38.045,
        "endTime": 39.105,
        "transcript": "Tamakut.",
        "translation": "Those."
    },
    "8": {
        "startTime": 41.17,
        "endTime": 45.34,
        "transcript": "Murilkenritaqaceteng cat arutuut.",
        "translation": "When they don't care for things, they deteriorate."
    },
    "9": {
        "startTime": 46.33,
        "endTime": 51.11,
        "transcript": "Rotten-aarluteng mecungtaarcetaqaceteng.",
        "translation": "They become rotten when they let them get wet repeatedly."
    },
    "10": {
        "startTime": 54.075,
        "endTime": 59.795,
        "transcript": "Cat murilkurluki pitullrulriit yuut tamakut.",
        "translation": "Those people carefully watched things."
    },
    "11": {
        "startTime": 60.92,
        "endTime": 63.54,
        "transcript": "Neqnek-qaa cali ayuqluteng?",
        "translation": "Was it the same with food?"
    },
    "12": {
        "startTime": 63.675,
        "endTime": 69.495,
        "transcript": "Neqet-llu kenkurluki, neqautait-ll' assiraqluteng.",
        "translation": "They treated their food with love, and their stores of food would be good."
    },
    "13": {
        "startTime": 71.28,
        "endTime": 79.91,
        "transcript": "Kitak' ayagyuat camek nallunritesqumallerpenek tamalkuita umyuavni uitalriit",
        "translation": "Now, whatever you want young people to know, everything that's in your mind"
    },
    "14": {
        "startTime": 79.91,
        "endTime": 88.15,
        "transcript": "Tamakunek, iciw' arnat ayagyuat, iciw' wangkugcetun wall'u-q' ayagyuat...",
        "translation": "Those, you know, young women, you know like us or the young ones..."
    },
    "15": {
        "startTime": 88.155,
        "endTime": 90.605,
        "transcript": "Nutaan-llu adult-aurtellriit.",
        "translation": "And those who've just become adults."
    },
    "16": {
        "startTime": 90.605,
        "endTime": 91.2,
        "transcript": "Ai?",
        "translation": "What?"
    },
    "17": {
        "startTime": 91.2,
        "endTime": 97.23,
        "transcript": "Camek maligtaqullerkamek qanrucukek'ngarpenek.",
        "translation": "Whatever you want to say that they should follow."
    },
    "18": {
        "startTime": 97.23,
        "endTime": 103.14,
        "transcript": "Umyuarpeni uitallriit tamalkuita qaruteksukten piluki.",
        "translation": "Say all of the things in your mind that would to talk about."
    },
    "19": {
        "startTime": 106.02,
        "endTime": 112.58,
        "transcript": "Adult-aurtaqa-w' tua-i qanrut'lallrukait",
        "translation": "When they became adults, they would tell them"
    },
    "20": {
        "startTime": 113.015,
        "endTime": 121.795,
        "transcript": "Wangkuta ayagyuallemteńi alerquutengqellruukut not to make love with a man before you get married.",
        "translation": "When we were young, we had the instruction not to make love with a man before you get married."
    },
    "21": {
        "startTime": 123.76,
        "endTime": 128.76,
        "transcript": "Angutmun pisqevkenata aipangvailemta.",
        "translation": "They told us not to give ourselves to men before we got married."
    },
    "22": {
        "startTime": 131.185,
        "endTime": 134.335,
        "transcript": "Tuaten qanrutetulruitkut.",
        "translation": "That's what they used to tell us."
    },
    "23": {
        "startTime": 134.335,
        "endTime": 144.975,
        "transcript": "Maa-i, maa-i waniw' tuaten arnat pilriit qaillun qanrucugciki?",
        "translation": "Now, what do you want to tell the women who do that now?"
    },
    "24": {
        "startTime": 146.23,
        "endTime": 147.43,
        "transcript": "Iciw'...",
        "translation": "You know..."
    },
    "25": {
        "startTime": 147.435,
        "endTime": 156.415,
        "transcript": "Amllerem-wa qanrut'laryaaqekai aipangvailgan angutmun kenkesqevkenaku.",
        "translation": "Many probably tell them that before they get married, not to have a man \"love\" them."
    },
    "26": {
        "startTime": 156.72,
        "endTime": 165.46,
        "transcript": "Tau͡gaam maa-i waten-llu aipaqliupailegmeng aipaqsuitellruut ak'a.",
        "translation": "But now, they didn't get into relationships before getting married long ago."
    },
    "27": {
        "startTime": 167.365,
        "endTime": 169.78,
        "transcript": "Ciin-gguq tuaten pisqumanriceciu?",
        "translation": "Why are they told not to do that?"
    },
    "28": {
        "startTime": 169.78,
        "endTime": 170.33,
        "transcript": "Ai?",
        "translation": "What?"
    },
    "29": {
        "startTime": 170.33,
        "endTime": 172.6,
        "transcript": "Ciin-gguq tuaten pisqumanriceta?",
        "translation": "Why are we told not to do that?"
    },
    "30": {
        "startTime": 172.6,
        "endTime": 183.17,
        "transcript": "Maa-i-wa ilateng tangerrluki makut girlfriend-angluteng boyfriend-angqerraqluteng-llu pilalriit.",
        "translation": "Now, looking at their peers, they get girlfriends and have boyfriends."
    },
    "31": {
        "startTime": 184.89,
        "endTime": 185.93,
        "transcript": "I mean, iciw'...",
        "translation": "I mean, you know..."
    },
    "32": {
        "startTime": 185.935,
        "endTime": 191.315,
        "transcript": "Ak'a tamakut yuut umyugiuyuitellruut ayagyuat.",
        "translation": "Long ago, those people, young people, didn't follow their every whim."
    },
    "33": {
        "startTime": 192.08,
        "endTime": 197.96,
        "transcript": "Kitak' qanrutqerkut iciw' ciin tuaten iciw'",
        "translation": "Please tell us, you know, why [it's told] that way, you know"
    },
    "34": {
        "startTime": 197.965,
        "endTime": 205.155,
        "transcript": "Angayuqavet iciw' qanrut'lallrullikiiten iciw' anguciuresqevkenak wall'u-q' piciatun.",
        "translation": "You know, your parent probably told you, you know, not to flirt with men or various things."
    },
    "35": {
        "startTime": 205.155,
        "endTime": 207.85,
        "transcript": "Ciin-gguq tuaten iciw'...",
        "translation": "Why [is it told] that way, you know..."
    },
    "36": {
        "startTime": 207.85,
        "endTime": 209.36,
        "transcript": "Qanrutanga-qaa?",
        "translation": "Why (s)he told me?"
    },
    "37": {
        "startTime": 209.36,
        "endTime": 216.04,
        "transcript": "Iciw' qanrutkeqerr' kitak' qaill' qanlallruciitnek, im'u",
        "translation": "You know, please talk about what they used to say, you know"
    },
    "38": {
        "startTime": 216.635,
        "endTime": 221.685,
        "transcript": "Iciw' aipaqilaqan qaillun piarkaucianek qanruyutaitnek.",
        "translation": "You know, the traditional wisdom concerning what would happen if they're promiscuous."
    },
    "39": {
        "startTime": 223.195,
        "endTime": 229.705,
        "transcript": "Tua-i-wa pisqevkenaki aipangvailgan angutmek kenkisqevkenaku.",
        "translation": "They told them not to, not to \"love\" men before they get married."
    },
    "40": {
        "startTime": 230.145,
        "endTime": 238.555,
        "transcript": "Kasngunarquq-gguq irniangekuni aipaunani aatailngurmek.",
        "translation": "They said it's shameful if she has an illegitimate child without a spouse."
    },
    "41": {
        "startTime": 239.305,
        "endTime": 242.865,
        "transcript": "Tuaten qanrutaqluki.",
        "translation": "That's what they told them."
    },
    "42": {
        "startTime": 258.02,
        "endTime": 265.28,
        "transcript": "Cangakan-qaa maa-i amllessiyaagateng arnat irningellrat aipainateng?",
        "translation": "Do you disapprove of the fact that there are too many women who have children without spouses?"
    },
    "43": {
        "startTime": 266.105,
        "endTime": 268.745,
        "transcript": "Aipaunateng-qaa irniangelallrit?",
        "translation": "How they have children without spouses?"
    },
    "44": {
        "startTime": 270.06,
        "endTime": 276.63,
        "transcript": "Yuut-wa tamalkuita allayuurcata cangakengramki qaill' qanerciigat'lalrianga.",
        "translation": "Well, since all people have become so different, I can't say anything though I disapprove of them."
    },
    "45": {
        "startTime": 277.95,
        "endTime": 280.61,
        "transcript": "Nuu, qaill' umyuartequciki?",
        "translation": "No, what do you think of them?"
    },
    "46": {
        "startTime": 281.565,
        "endTime": 284.26,
        "transcript": "Qaillun umyuartequciki-gguq?",
        "translation": "What do you think of them?"
    },
    "47": {
        "startTime": 284.26,
        "endTime": 288.9,
        "transcript": "Maa-i iciw' yuut ayuqenrilriit? Qaillun umyuartequciki?",
        "translation": "You know how people are different now? What do you think of them?"
    },
    "48": {
        "startTime": 288.905,
        "endTime": 300.535,
        "transcript": "Iciw' ayagyuallerpeni ayuqutekluki maa-i, maa-i yuut ayuqellritnek, arnat ayagyuat ayagyuallerpeni ak'a imumi.",
        "translation": "You know, comparing them to when you were young, what people are like now, how young people were like when you were young long ago."
    },
    "49": {
        "startTime": 300.535,
        "endTime": 304.45,
        "transcript": "Qaillun iciw' compare-arlukek.",
        "translation": "You know, comparing them somehow."
    },
    "50": {
        "startTime": 304.45,
        "endTime": 311.95,
        "transcript": "Ellait-llu-wa ayagyuat ayagaluteng piyaurcameng angayuqateng nayuqsaunaki.",
        "translation": "It's also because those young people have started traveling around, not being with their parents."
    },
    "51": {
        "startTime": 312.675,
        "endTime": 321.965,
        "transcript": "Iciw' tua-i high school-amek graduate-arqameng avtelalriit, ellmeggnek pingluteng college-aarluteng.",
        "translation": "You know, they separate when they graduate from high school, going off on their own, going to college."
    },
    "52": {
        "startTime": 322.055,
        "endTime": 327.795,
        "transcript": "Umyuateng cimirluki ellaita piyullmeggnek aturluteng..",
        "translation": "They change their minds, doing what they want to do."
    },
    "53": {
        "startTime": 327.97,
        "endTime": 332.43,
        "transcript": "Tuaten pilalriit. Amlleq tuaten pilria.",
        "translation": "They do that. Many do that."
    },
    "54": {
        "startTime": 337.295,
        "endTime": 347.055,
        "transcript": "Avtelaamegteki angayuqateng, iciw' tua-i graduate-araqameng college-aanun ayagluteng elitnaurluteng.",
        "translation": "It's because they separate from their parents, you know, they leave for college when they graduate to get education."
    },
    "55": {
        "startTime": 347.41,
        "endTime": 350.61,
        "transcript": "Ellaita piyullmeggnek piluteng.",
        "translation": "They do what they want."
    },
    "56": {
        "startTime": 351.305,
        "endTime": 357.92,
        "transcript": "Yuut ayuqenrilameng, ilaita angayuqameng qanellrit umyuaqaqluki",
        "translation": "Because people are different, some of them remember what their parents taught"
    },
    "57": {
        "startTime": 357.92,
        "endTime": 367.83,
        "transcript": "Ilii-llu angayuqami qanellra umyuaqevkenaku, elliin tau͡gaam tangvallni ayuqellrit ayuqengnaqluki ayuqluteng",
        "translation": "And some does not remember what his parent said, instead trying to be like the ones that he's watched"
    },
    "58": {
        "startTime": 370.73,
        "endTime": 373.25,
        "transcript": "Yuut ayuqeksailameng.",
        "translation": "Because people are different."
    },
    "59": {
        "startTime": 376.99,
        "endTime": 384.34,
        "transcript": "Ilii-llu amlleq taangaryugluni. Ayagyuange'rmeng taangaryugaqluteng.",
        "translation": "And many tend to drink alcohol. They tend to drink even though they're young."
    },
    "60": {
        "startTime": 387.5,
        "endTime": 395.92,
        "transcript": "Kitak' angayuqaagpet grandparents-aarpet-llu qanruyutek'lallritnek qanrutqerkut",
        "translation": "Please tell us about the traditional wisdom your parents and grandparents shared"
    },
    "61": {
        "startTime": 395.925,
        "endTime": 399.055,
        "transcript": "Iciw' alerqualu[ten].",
        "translation": "You know, instructing you."
    },
    "62": {
        "startTime": 399.055,
        "endTime": 402.895,
        "transcript": "Grandparents-aagka wii tuqullruuq tamaa.",
        "translation": "My grandparents died early on."
    },
    "63": {
        "startTime": 404.17,
        "endTime": 408.57,
        "transcript": "Qaillurraq tayim' angtalua apa'urluqa tuquluni.",
        "translation": "My grandfather died when I was at some young age."
    },
    "64": {
        "startTime": 412.395,
        "endTime": 415.335,
        "transcript": "Maurluma tau͡gaam keneklua",
        "translation": "But my grandmother loved me"
    },
    "65": {
        "startTime": 416.26,
        "endTime": 422.28,
        "transcript": "Kiimnuk-llu uitaaqlunuk parents-aagka uksuiyaraqagnek, wiinga elitnaurlua.",
        "translation": "And we would stay alone when my parents went to winter camp, as I went to school."
    },
    "66": {
        "startTime": 422.455,
        "endTime": 428.565,
        "transcript": "I was only about maybe six. Six-aarngatua-ll' tayima, six seven, eight.",
        "translation": "I was only about maybe six. I think I was six, six, seven, eight."
    },
    "67": {
        "startTime": 428.745,
        "endTime": 432.945,
        "transcript": "Eight-aallemni tayim' maurluqa tuqullrungatuq.",
        "translation": "I think my grandmother died when I was eight."
    },
    "68": {
        "startTime": 433.31,
        "endTime": 438.75,
        "transcript": "Amllermek murilkessiyaangvailemni tuquluni.",
        "translation": "She died before I could watch her do too many things."
    },
    "69": {
        "startTime": 444.535,
        "endTime": 449.325,
        "transcript": "Angayuqaagka-llu canun ayagayuitellruamek",
        "translation": "And because my parents didn't go to various villages"
    },
    "70": {
        "startTime": 450.055,
        "endTime": 457.075,
        "transcript": "Yuut ayagaurayuitellruut watua pilallracetun.",
        "translation": "People didn't travel to many villages as they do now."
    },
    "71": {
        "startTime": 458.7,
        "endTime": 464.11,
        "transcript": "Ayagayuunatek tau͡gaam tua-i cangnatuglutek every day.",
        "translation": "They didn't travel to villages, but they worked hard to survive every day."
    },
    "72": {
        "startTime": 464.27,
        "endTime": 467.4,
        "transcript": "Ataka pissurluni.",
        "translation": "My father hunted."
    },
    "73": {
        "startTime": 467.74,
        "endTime": 479.97,
        "transcript": "Una-llu aanaput cat aturkaput mingeqluki, neqkiurluta tuaten, neqkat-llu murilkelluki.",
        "translation": "And our mother would sew our clothes, even made food for us, and attended to what would be our food."
    },
    "74": {
        "startTime": 480.82,
        "endTime": 486.59,
        "transcript": "Tangvallregka taukuk yugnun-ll' ayagayuunatek.",
        "translation": "The two I watched wouldn't go to other people all the time."
    },
    "75": {
        "startTime": 489.38,
        "endTime": 496.5,
        "transcript": "Waten tau͡gaam ataka Paingarmiuni ilangqerrami, uncle-aangqerrami",
        "translation": "But because my father had relatives, an uncle, in Paingarmiut like this"
    },
    "76": {
        "startTime": 496.505,
        "endTime": 500.815,
        "transcript": "Yuraqataraqata ayagaqluta tuavet.",
        "translation": "When they were going to hold dance festivals, we would travel there."
    },
    "77": {
        "startTime": 504.795,
        "endTime": 509.245,
        "transcript": "Yuut au͡gkut ciuqliit tangvalput yuralgullruut.",
        "translation": "Those first people we watched long ago always had dance festivals."
    },
    "78": {
        "startTime": 509.915,
        "endTime": 515.615,
        "transcript": "Yuralriit arulaiqsaunateng. Uksuarmek ayagluteng yurangaqluteng.",
        "translation": "They wouldn't stop having dance festivals. They would start holding dance festivals starting in the fall."
    },
    "79": {
        "startTime": 515.76,
        "endTime": 519.9,
        "transcript": "Yuut-llu, Yupiat caciryarait amllerrluteng.",
        "translation": "And people, Yupiit, had a lot of practices."
    },
    "80": {
        "startTime": 519.905,
        "endTime": 524.435,
        "transcript": "Qaariitaatuluta-llu October-aami.",
        "translation": "We would also practice Yup'ik Halloween in October."
    },
    "81": {
        "startTime": 527.035,
        "endTime": 530.745,
        "transcript": "Qangvaq ayagnillrua tamana Qaariitaaryaurtelci?",
        "translation": "When did your Yup'ik Halloween practice start?"
    },
    "82": {
        "startTime": 530.935,
        "endTime": 535.75,
        "transcript": "Ak'a-w' maaten ellangua tuaten pituluteng yuut.",
        "translation": "In my earliest memories, people had already been doing that."
    },
    "83": {
        "startTime": 535.75,
        "endTime": 540.84,
        "transcript": "Atam Qaariitaarluteng, neqlilluteng-llu.",
        "translation": "You see, they would practice Yup'ik Halloween, and would give out food."
    },
    "84": {
        "startTime": 541.23,
        "endTime": 547.49,
        "transcript": "Neqlitaqluki yuut irniameng atqestait.",
        "translation": "They would give food to people, their children's namesakes."
    },
    "85": {
        "startTime": 549.86,
        "endTime": 555.21,
        "transcript": "Neqlilluki waten qantamek cikirluki, imirluku assircaarluku.",
        "translation": "They would give food by handing out a bowl like this, filling it well."
    },
    "86": {
        "startTime": 555.21,
        "endTime": 560.86,
        "transcript": "Merr'illuki-llu, mermek cikirluku mertelluki.",
        "translation": "And they gave them water, they gave them water to drink."
    },
    "87": {
        "startTime": 561.41,
        "endTime": 563.81,
        "transcript": "Qantamek-llu cikirluku.",
        "translation": "And give [the child] a bowl."
    },
    "88": {
        "startTime": 567.805,
        "endTime": 575.445,
        "transcript": "Cayarait amllellruut au͡gkut tangvallrenka, wagg'uq ukut Nunacuarmiut.",
        "translation": "The people I watched back then had a lot of practices, the place they called Nunacuarmiut."
    },
    "89": {
        "startTime": 576.49,
        "endTime": 581.1,
        "transcript": "Tua-i-ll' cali Ingularluteng.",
        "translation": "Then they would also hold the Ingulaq dance festival."
    },
    "90": {
        "startTime": 581.1,
        "endTime": 586.97,
        "transcript": "Qasgiteng imlluku, kituggluku, kelgiluteng nunanek.",
        "translation": "They demolished their community house, fixed it, and invited villages."
    },
    "91": {
        "startTime": 586.97,
        "endTime": 592.93,
        "transcript": "Nunat-llu tekicameng qasgiq wanirpak taqluku unugpailgan.",
        "translation": "Then when the villages arrived, they finished the community house right away before night fell."
    },
    "92": {
        "startTime": 593.175,
        "endTime": 598.455,
        "transcript": "Atakuan-llu yurarluteng, ingularluteng.",
        "translation": "Then they danced in the evening, the woman dancing slowly."
    },
    "93": {
        "startTime": 599.71,
        "endTime": 604.11,
        "transcript": "Imkunek yuarucirluteng cukailngurnek yuarutnek",
        "translation": "They would sing slow songs"
    },
    "94": {
        "startTime": 604.115,
        "endTime": 606.705,
        "transcript": "Cauyaq-llu cukaunani.",
        "translation": "And the drumbeat was slow."
    },
    "95": {
        "startTime": 607.085,
        "endTime": 614.455,
        "transcript": "Arnaq una itraqluni qantamek tegumiarluni, tua-i-gguq Ingulautminek.",
        "translation": "A woman would come in holding a bowl, what they called her Ingulaun [Ingulaq bowl]."
    },
    "96": {
        "startTime": 615.165,
        "endTime": 625.375,
        "transcript": "Qantaq-llu qasgim qukaanun natermun ellirraarluku yurarluni arnaq tauna.",
        "translation": "Then after she placed the bowl on the floor in the middle of the community house, that woman would Yup'ik dance."
    },
    "97": {
        "startTime": 627.645,
        "endTime": 630.045,
        "transcript": "Ingularluteng.",
        "translation": "They held the Ingulaq festival."
    },
    "98": {
        "startTime": 630.21,
        "endTime": 636.54,
        "transcript": "Tua-i-llu Ingularraartelluki call' kinguakun",
        "translation": "Then after they held the Ingulaq festival"
    },
    "99": {
        "startTime": 637.5,
        "endTime": 642.25,
        "transcript": "Waniw' qenuqatarluku-gguq Elciluteng-gguq",
        "translation": "They said that before it froze they would celebrate Elciq [beginning of Bladder Festival]."
    },
    "100": {
        "startTime": 642.88,
        "endTime": 647.47,
        "transcript": "Qantanek tagulluteng qasgimun.",
        "translation": "Bringing bowls inland to the community house."
    },
    "101": {
        "startTime": 650.55,
        "endTime": 655.99,
        "transcript": "Qasgit-llu hallway-nek tunnel-aanek amigluni.",
        "translation": "And the community houses had hallways, [or] tunnels as entrances."
    },
    "102": {
        "startTime": 656.705,
        "endTime": 665.36,
        "transcript": "Arnaq cakmani elaturrami, waniw' amiigni call' arnaq, una-w' call' amigmi arnaq.",
        "translation": "There was a woman out there in the enclosed entry area, then a woman by this [outer] entrance, and awoman here by the [inner] entrance."
    },
    "103": {
        "startTime": 665.36,
        "endTime": 673.05,
        "transcript": "Qantaq wani tun'urluku waken qasgim amiiganek.",
        "translation": "They passed the bowl from here by the entrance of the community house."
    },
    "104": {
        "startTime": 674.237,
        "endTime": 678.172,
        "transcript": "Pim-gguq wanigg' Elcitii qantaput.",
        "translation": "They said that this is this person's Elciq bowl, our bowls."
    },
    "105": {
        "startTime": 678.172,
        "endTime": 682.912,
        "transcript": "Atput aperturaqaki qantaput aqvaaqluku.",
        "translation": "When they called our names, we would get our bowl."
    },
    "106": {
        "startTime": 683.337,
        "endTime": 685.907,
        "transcript": "Nunaniqluni.",
        "translation": "It was a joyous time."
    },
    "107": {
        "startTime": 686.297,
        "endTime": 689.157,
        "transcript": "Elciluteng-gguq tua-i.",
        "translation": "They called that the Elciq festival."
    },
    "108": {
        "startTime": 692.252,
        "endTime": 694.952,
        "transcript": "Caqtaalguluteng.",
        "translation": "They always did various practices."
    },
    "109": {
        "startTime": 697.177,
        "endTime": 702.117,
        "transcript": "Tuamtell' cali icivaumainanrani Kevgirluteng.",
        "translation": "Then soon after, they would hold the Messenger Feast."
    },
    "110": {
        "startTime": 702.452,
        "endTime": 705.642,
        "transcript": "Kevgak ayaglutek nunanun.",
        "translation": "The messengers traveled to villages."
    },
    "111": {
        "startTime": 707.292,
        "endTime": 713.802,
        "transcript": "Practice-aaqatarluteng uksurpak yuarutnek piyuutnek",
        "translation": "They were going to practice requesting songs all winter"
    },
    "112": {
        "startTime": 714.022,
        "endTime": 718.052,
        "transcript": "Canek agyunek, piyuutnek-llu.",
        "translation": "[Songs for] things, requests from other things, and things they wanted."
    },
    "113": {
        "startTime": 719.322,
        "endTime": 728.762,
        "transcript": "Yurarluteng imkunek yuraraqluteng practice-aaraqluteng imkunek yurautnek cukalrianek.",
        "translation": "They would Yup'ik dance, practice dancing with those fast Yup'ik dancing songs."
    },
    "114": {
        "startTime": 729.187,
        "endTime": 734.057,
        "transcript": "Fast, cukaluteng yuarutet, cauyat-lu cukaluteng.",
        "translation": "Fast, the songs were fast, and the drumbeats were fast."
    },
    "115": {
        "startTime": 734.337,
        "endTime": 744.337,
        "transcript": "Arnat yuraquaqluteng, qavaruarluteng, tuntussuruarluteng, petmigcurluteng.",
        "translation": "The woman would dance songs about sleeping, hunting caribou, setting pit traps."
    },
    "116": {
        "startTime": 745.682,
        "endTime": 753.532,
        "transcript": "Canguarturluteng yuratuluteng ancestor-aameng yurainek.",
        "translation": "They would Yup'ik dance depicted various things, their ancestors dances."
    },
    "117": {
        "startTime": 755.982,
        "endTime": 759.302,
        "transcript": "Motion-aarinek yuratuluteng.",
        "translation": "They would dance with their [ancestor's] motions."
    },
    "118": {
        "startTime": 761.417,
        "endTime": 771.152,
        "transcript": "Allat-llu cali elitnaurluteng akiqliqellriik yuuk iciw' imkunek yurapignek.",
        "translation": "The the others, two people across from each other would learn, you know, those real [ancient] Yup'ik dances."
    },
    "119": {
        "startTime": 771.152,
        "endTime": 774.912,
        "transcript": "Tua-i-gguq tekiqata'arcuutekiurluteng.",
        "translation": "They called that preparing the arrival dance for guests."
    },
    "120": {
        "startTime": 777.227,
        "endTime": 784.362,
        "transcript": "Tua-i-llu uksurpak tua-i pilnguameng upingariameng",
        "translation": "Then when they were tired of doing that all winter and they were ready"
    },
    "121": {
        "startTime": 784.362,
        "endTime": 791.542,
        "transcript": "Tunutekateng-llu agyuput, agyumta tunutekait upingariluteng",
        "translation": "And when the thigns we were going to give as requested, when the thigns they were going to give as requested were ready"
    },
    "122": {
        "startTime": 791.547,
        "endTime": 795.607,
        "transcript": "Yuarutet-llu upluki piyuutet.",
        "translation": "They also prepared the requesting songs."
    },
    "123": {
        "startTime": 795.872,
        "endTime": 804.082,
        "transcript": "\"Pinaurai-qaa kinakucim-qaa camek ima-qaa qaillun pilriamek?\"",
        "translation": "\"Would some random person give them something as they requested?\""
    },
    "124": {
        "startTime": 804.292,
        "endTime": 807.822,
        "transcript": "Tua-i anglanaqluteng yura'arqameng.",
        "translation": "They would be fun when they danced."
    },
    "125": {
        "startTime": 810.282,
        "endTime": 818.092,
        "transcript": "Tua-i-llu tekiqata'arqata kel'kengateng tekicata",
        "translation": "Then when they danced the arrival dance when the ones they invited arrived"
    },
    "126": {
        "startTime": 820.462,
        "endTime": 824.702,
        "transcript": "Invite-alteng nunat allat tekicata",
        "translation": "When the other villages they invited arrived"
    },
    "127": {
        "startTime": 824.707,
        "endTime": 827.947,
        "transcript": "Angutet qasgivkarluki.",
        "translation": "They had the men go to the community house."
    },
    "128": {
        "startTime": 828.402,
        "endTime": 833.582,
        "transcript": "Qasgim-llu ingelran iliit un'gavet elliluku qulvanun.",
        "translation": "And they placed one of the beds in the community house toward the door high up there."
    },
    "129": {
        "startTime": 833.657,
        "endTime": 839.277,
        "transcript": "Taukut-llu angutet tamaavet aqumlluki payugarrluki.",
        "translation": "Then they sat those men there and brought them food."
    },
    "130": {
        "startTime": 840.092,
        "endTime": 842.672,
        "transcript": "Tua-i-gguq payugarrluki.",
        "translation": "They called that bringing them food."
    },
    "131": {
        "startTime": 843.297,
        "endTime": 852.507,
        "transcript": "Neqkaitnek payuggluki neqnek keniranek, wall'u, wall' dry fish-aanek, yuurqerkaitnek-llu.",
        "translation": "They would bring them cooked food to ear, or dried fish, and something hot to drink."
    },
    "132": {
        "startTime": 852.637,
        "endTime": 860.967,
        "transcript": "Tua-i-llu nernerrlugcetaariluteng nerngarcata tamakut allanret angutet.",
        "translation": "Then when those male guests started eating, they sung ridiculing songs so they wouldn't eat in peace."
    },
    "133": {
        "startTime": 860.967,
        "endTime": 866.597,
        "transcript": "Nerngarcata yuarutmek emengluteng nunat.",
        "translation": "When they started eating, the [host] village would start softly drumming a song."
    },
    "134": {
        "startTime": 867.607,
        "endTime": 870.727,
        "transcript": "Tua-i-gguq nernerrlugcetaarluki.",
        "translation": "They called that ridiculing them through song as they ate."
    },
    "135": {
        "startTime": 870.802,
        "endTime": 874.142,
        "transcript": "Apa'urluunka aqumlua tangvakenka.",
        "translation": "I sat and watched my grandfathers and great-uncles."
    },
    "136": {
        "startTime": 874.147,
        "endTime": 878.147,
        "transcript": "Last one, that was the last one.",
        "translation": "Last one, that was the last one."
    },
    "137": {
        "startTime": 878.442,
        "endTime": 885.722,
        "transcript": "Murilkelluku tangvallruaqa atama uncle-aari Paingarmiut.",
        "translation": "I carefully watched my father's uncles from Paingarmiut."
    },
    "138": {
        "startTime": 885.727,
        "endTime": 897.397,
        "transcript": "Waten Nunacuarmiut atulriit atuulluki nernerrlugcetaarluki so they can choke, or can't swallow, or something like that.",
        "translation": "The people of Nunacuarmiut sung like this, ridiculing them through song as they ate so they can choke, or can't swally, or something like that."
    },
    "139": {
        "startTime": 897.397,
        "endTime": 899.387,
        "transcript": "Atuuskait waten:",
        "translation": "They sung to them like this:"
    },
    "140": {
        "startTime": 899.762,
        "endTime": 909.272,
        "transcript": "\"Talluryuyuilngurnun nalirrugcetaarilii.",
        "translation": "\"Let me give those with no shame a hard choice."
    },
    "141": {
        "startTime": 909.422,
        "endTime": 916.592,
        "transcript": "\"Nalirriarrngualriit avukuulluki-qaa?",
        "translation": "\"Shall I lump together those who are undecided?"
    },
    "142": {
        "startTime": 917.062,
        "endTime": 930.012,
        "transcript": "\"Ata-ggem ukuni Akulurarmiuni aturyuktaalarmiut.",
        "translation": "\"Don't these people from Akuluraq also like to sing?"
    },
    "143": {
        "startTime": 930.252,
        "endTime": 940.642,
        "transcript": "\"Cakegtaunriluciq calliggluku maavet aturyuktaarlarmiut.\"",
        "translation": "\"They also like to sing, scattering about unfavorable things here.\""
    },
    "144": {
        "startTime": 940.642,
        "endTime": 952.422,
        "transcript": "Imkuk-ll' apallirtulriik angutek matarmek, uyamignek makurlutek, nasqurruterlutek, qerrulliglutek tau͡gaam waten elliurlutek.",
        "translation": "And the two men singing the verses naked, with necklaces here, with headresses, but with pants, were doing this."
    },
    "145": {
        "startTime": 952.957,
        "endTime": 954.967,
        "transcript": "Tua-i-ll' enipagluki",
        "translation": "Then they pointed right at them"
    },
    "146": {
        "startTime": 954.967,
        "endTime": 960.617,
        "transcript": "\"Unagkurluut-llam pivakengraata.\"",
        "translation": "\"And though the poor people down there think highly of themselves.\""
    },
    "147": {
        "startTime": 960.927,
        "endTime": 964.067,
        "transcript": "Ala-i alingnaqluteng.",
        "translation": "Oh my, they were intimidating."
    },
    "148": {
        "startTime": 964.622,
        "endTime": 968.172,
        "transcript": "Tua-i-gguq nernerrlugcetaarluki.",
        "translation": "They called that ridiculing them through song as they ate."
    },
    "149": {
        "startTime": 968.292,
        "endTime": 974.532,
        "transcript": "Wii tua-i tangvakenka tamakut apa'urluunka, atama uncle-aari.",
        "translation": "I watched my great-uncles there, my father's uncles."
    },
    "150": {
        "startTime": 978.177,
        "endTime": 985.117,
        "transcript": "That was the last one. I never, nalluyagucuunaku-ll' yuarutiit.",
        "translation": "That was the last one. And I never forgot their song."
    },
    "151": {
        "startTime": 986.182,
        "endTime": 991.212,
        "transcript": "Elitnauryuyuama-ll' yuranek yuaruteksularyaaqekeka.",
        "translation": "And because I teach Yup'ik dances, I want to use that song."
    },
    "152": {
        "startTime": 991.212,
        "endTime": 996.882,
        "transcript": "Cangaknayukluku yuarutkeksailkeka. Anglanaksaaqaqa.",
        "translation": "I haven't used that song because they might be offended. I find it fun."
    },
    "153": {
        "startTime": 996.882,
        "endTime": 1002.352,
        "transcript": "Atam yurat anglanakanka yuraliyaryunqellruama-llu.",
        "translation": "You see, I find Yup'ik dances fun because I liked going to dance festivals."
    },
    "154": {
        "startTime": 1003.322,
        "endTime": 1010.002,
        "transcript": "Tua-i yuralrianun unegcuunii yuraliyaraqellrianga.",
        "translation": "I would go to dance festivals and not stay behind [at home] for the dancing."
    },
    "155": {
        "startTime": 1010.777,
        "endTime": 1016.477,
        "transcript": "Tua-i-ll' Kassiglumun upagluta Kassiglurmiut nunaurtellratni.",
        "translation": "Then we moved to Kasigluk when Kasigluk was established as a village."
    },
    "156": {
        "startTime": 1017.842,
        "endTime": 1022.402,
        "transcript": "Last one-aamek Kevgilriit 1935.",
        "translation": "The last Messenger Feast they held was in 1935."
    },
    "157": {
        "startTime": 1023.537,
        "endTime": 1029.617,
        "transcript": "Tua-i-llu yuramek taqluteng nunat tamarmeng.",
        "translation": "Then every village stopped Yup'ik dancing."
    },
    "158": {
        "startTime": 1030.312,
        "endTime": 1033.042,
        "transcript": "Tua-i yurayuirulluteng.",
        "translation": "They stopped holding dance festivals."
    },
    "159": {
        "startTime": 1033.042,
        "endTime": 1037.522,
        "transcript": "Elciyuirulluteng, neqlicuirulluteng-llu.",
        "translation": "They stopped celebrating Elciq, and they stopped giving out food."
    },
    "160": {
        "startTime": 1037.527,
        "endTime": 1039.597,
        "transcript": "Cat taqluki.",
        "translation": "They stopped those festivals."
    },
    "161": {
        "startTime": 1040.717,
        "endTime": 1043.587,
        "transcript": "Tua-i cat yuarnaqluteng.",
        "translation": "I miss those things."
    },
    "162": {
        "startTime": 1047.127,
        "endTime": 1053.417,
        "transcript": "Imkut wani agayulirtet, Moravian people, taqevkarluki.",
        "translation": "Those priests, Moravian people, had them stop."
    },
    "163": {
        "startTime": 1053.487,
        "endTime": 1064.037,
        "transcript": "Anagulluki-llu yurautelallratnek, tamakunek picirluteng taqevkarluki",
        "translation": "And because they danced excessively for people, that was the reason they had them stop"
    },
    "164": {
        "startTime": 1064.967,
        "endTime": 1068.937,
        "transcript": "Canek pilluarqelluteng pitullrat.",
        "translation": "They way they gave out gifts."
    },
    "165": {
        "startTime": 1077.427,
        "endTime": 1083.437,
        "transcript": "Yurat yuarnarqellruut yurayuirutlermeggni. Wiinga-w' yuallrukenka.",
        "translation": "People missed Yup'ik dancing when they stopped dancing. Well, I personally missed them."
    },
    "166": {
        "startTime": 1084.187,
        "endTime": 1086.987,
        "transcript": "Tua-i-llu wangkuk",
        "translation": "Then we"
    },
    "167": {
        "startTime": 1091.202,
        "endTime": 1097.782,
        "transcript": "Calligtaalnguamnuk uksuiyaraqlunuk, up'nerkiyaraqlunuk, caqtaalnguamnuk",
        "translation": "Since we were tired of moving about, going to winter camp, going to spring camp, since we were tired of doing various things"
    },
    "168": {
        "startTime": 1099.857,
        "endTime": 1105.677,
        "transcript": "We start live in Bethel, 1943. That's long time.",
        "translation": "We start liv[ing] in Bethel, 1943. That's [a] long time."
    },
    "169": {
        "startTime": 1107.432,
        "endTime": 1110.022,
        "transcript": "Mary-ll' maani yuurrluni.",
        "translation": "And Mary was born here."
    },
    "170": {
        "startTime": 1111.562,
        "endTime": 1117.642,
        "transcript": "Yuurtengraan aipaqa kiugg' pissuryaraqluni uksuarmi.",
        "translation": "Though she was born, my spouse in there would hunt in the fall."
    },
    "171": {
        "startTime": 1118.477,
        "endTime": 1121.637,
        "transcript": "Parents-aagemnun wii ayaullua.",
        "translation": "He brought me to my parents."
    },
    "172": {
        "startTime": 1122.012,
        "endTime": 1128.472,
        "transcript": "Tuamta-ll' up'nerkami up'nerkiyaraqluta.",
        "translation": "Then in the spring, we would go to spring camp."
    },
    "173": {
        "startTime": 1130.107,
        "endTime": 1140.387,
        "transcript": "Tua-i-ll' mikelnguut amlleriata elitnaungata ayayuirulluta tua-i.",
        "translation": "Then because there were a lot of children, because they started going to school, we stopped traveling."
    },
    "174": {
        "startTime": 1140.722,
        "endTime": 1144.412,
        "transcript": "School-arluteng tau͡gaam kids-aat.",
        "translation": "Instead, the kids went to school."
    },
    "175": {
        "startTime": 1144.412,
        "endTime": 1154.252,
        "transcript": "Aatiit tau͡gaam ayagaqluni, Nushagak-amun-llu kuvyayaraqluni, uksuarmi-ll' pissuryaraqluni.",
        "translation": "But their father would travel, and go commercial fishing in Nushagak, and hunt in the fall."
    },
    "176": {
        "startTime": 1156.897,
        "endTime": 1160.147,
        "transcript": "Kiituan-llu calituriuq,.",
        "translation": "Eventually, he started working."
    },
    "177": {
        "startTime": 1160.607,
        "endTime": 1165.617,
        "transcript": "Ayagmek calilallruuq. Calinge'rmi tau͡gaam pissuryalallruuq.",
        "translation": "He worked from the start. But even though he worked, he'd go hunting."
    },
    "178": {
        "startTime": 1169.817,
        "endTime": 1176.567,
        "transcript": "Wani-ll' Mamterillermun tekiteqarraallemteńi nunakuarcuutek malruk,.",
        "translation": "And when we first came here to Bethel, there were two cars."
    },
    "179": {
        "startTime": 1178.007,
        "endTime": 1183.297,
        "transcript": "Nunakuarcuutertaunani. Sidewalk-anek tau͡gam tumyararluteng.",
        "translation": "There were no cars. The only paths were sidewalks."
    },
    "180": {
        "startTime": 1184.407,
        "endTime": 1188.877,
        "transcript": "Tua-i-ll' piqerluteng nunakuarcuutet amlleriluteng.",
        "translation": "Then there were suddenly an increase in cars."
    },
    "181": {
        "startTime": 1191.827,
        "endTime": 1197.907,
        "transcript": "NC-rullermini AC-rurpailegmi suuraqluteng.",
        "translation": "When it was NC, before it became AC, they would show movies."
    },
    "182": {
        "startTime": 1202.502,
        "endTime": 1205.142,
        "transcript": "Tangercetaaraqluteng.",
        "translation": "They would show movies."
    },
    "183": {
        "startTime": 1205.517,
        "endTime": 1208.632,
        "transcript": "Wii tangercetaaliaraqlua irnianka malikluki.",
        "translation": "I would go see movies, taking my children with me."
    },
    "184": {
        "startTime": 1208.632,
        "endTime": 1213.412,
        "transcript": "Akikit'lallruut tangercetaat, 50 cents akiluteng.",
        "translation": "Movies were cheap, priced at 50 cents."
    },
    "185": {
        "startTime": 1213.417,
        "endTime": 1221.797,
        "transcript": "Tua-i-ll' call' Swanson-aaq kipusviliami suurvililuni ikaggun bride-am akiakun angtuamek.",
        "translation": "Then when Swanson's became a store, they made a big movie theater across there on the other side of the bridge."
    },
    "186": {
        "startTime": 1222.412,
        "endTime": 1228.292,
        "transcript": "Suurnaurtut tang double feature from 7-12.",
        "translation": "They would show a double feature movie, from 7-12."
    },
    "187": {
        "startTime": 1228.717,
        "endTime": 1233.432,
        "transcript": "Long movie. Anglanarqaqluteng-llu movie-t.",
        "translation": "Long movie. And the movies would be fun."
    },
    "188": {
        "startTime": 1233.432,
        "endTime": 1243.222,
        "transcript": "Tua-i atakumi atakutarraarluta suurvigmun qerarluta suuraqluta atakurpak unugpak-llu.",
        "translation": "In the evening, after we had dinner, we would cross to the theather and watch movies all evening and all night."
    }
};